import { Modal, Typography, Input } from 'antd';
import notifier from 'utils/notifier';
import { ErrorResponse } from 'utils/types';
import FloatLabel from 'components/Common/FloatLabel';

const { Title } = Typography;

type ForgotPasswordModalProps = {
  handleForgotPassword(username: string, portalName: string): any,
  forgotPassword: boolean,
  setUsername(value: string): void,
  username: string,
  handleForgotPasswordModalClose(): void,
  handleForgotPasswordModalOpen(): void,
  isForgotPasswordModalVisible: boolean,
  selectedIpaGroup: string,
}

const ForgotPasswordModal = (props: ForgotPasswordModalProps) => {

  const SUCCESS = 0;
  const EMAIL_IS_NULL = 1;
  const NO_SUCH_USERNAME = 2;
  const EMAIL_SEND_FAILURE = 3;

  const submit = () => {
    if (!props.username) notifier.error('Please enter a username.');

    let selectedIpaGroup = props.selectedIpaGroup;
    if (selectedIpaGroup === 'APC') selectedIpaGroup = 'NMM';
    // if (selectedIpaGroup === 'BAIPA') selectedIpaGroup = 'BA';

    props.handleForgotPassword(props.username, selectedIpaGroup)
    .then((response: number) => {
      if (response === SUCCESS) {
        props.handleForgotPasswordModalClose();
        notifier.success('Successfully sent reset password email');
      } else if (response === EMAIL_IS_NULL) {
        notifier.error('No email attached to username.');
      } else if (response === NO_SUCH_USERNAME) {
        notifier.error('No such username exists.');
      } else if (response === EMAIL_SEND_FAILURE) {
        notifier.error('Email send failure.');
      } else {
        notifier.error('Something went wrong, please contact a system administrator.');
      }
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
    });
  }

  return (
    <>
      <Modal 
        visible={props.isForgotPasswordModalVisible} 
        onCancel={props.handleForgotPasswordModalClose} 
        onOk={submit}
        okButtonProps={{ loading: props.forgotPassword }}
        className="modal-width"
      >
        <div className="container">
          <Title level={3}>Forgot Password</Title>
        </div>
        <FloatLabel label="Username" value={props.username}>
          <Input
            value={props.username}
            onChange={e => props.setUsername(e.target.value)}
            />
        </FloatLabel>
      </Modal>
    </>
   );
}

export default ForgotPasswordModal;